// src/api/tenants.js
import { supabase } from '../supabaseClient';

const API_ORIGIN = (
  process.env.REACT_APP_API_URL || ''
).replace(/\/$/, '');

/** Get a bearer token, if any (Supabase first, then legacy localStorage). */
async function getAccessToken() {
  try {
    // Current Supabase session (already signed in)
    const { data: s1, error: e1 } = await supabase.auth.getSession();
    if (!e1 && s1?.session?.access_token) return s1.session.access_token;

    // Try refresh (e.g., page just loaded and session needs a refresh)
    const { data: s2, error: e2 } = await supabase.auth.refreshSession();
    if (!e2 && s2?.session?.access_token) return s2.session.access_token;
  } catch (_) {
    // ignore; we’ll try localStorage below
  }

  // Legacy fallback
  const legacy = localStorage.getItem('accessToken');
  return legacy || null;
}

/**
 * GET /api/tenants
 * 1) Try cookie-based auth (credentials: 'include')
 * 2) If 401/403, retry with Bearer token from Supabase (or legacy)
 */
export async function listAllTenants() {
  // 1) Cookie-first attempt (works if your backend set an auth cookie)
  let res = await fetch(`${API_ORIGIN}/api/tenants`, {
    method: 'GET',
    credentials: 'include',
  });

  // 2) If unauthorized, retry with Authorization header
  if (res.status === 401 || res.status === 403) {
    const token = await getAccessToken();
    if (!token) {
      throw new Error('No active Supabase session');
    }

    res = await fetch(`${API_ORIGIN}/api/tenants`, {
      method: 'GET',
      headers: { Authorization: `Bearer ${token}` },
      credentials: 'include',
    });
  }

  if (!res.ok) {
    const text = await res.text().catch(() => '');
    throw new Error(`Failed to load tenants: ${res.status}${text ? ` ${text}` : ''}`);
  }

  return res.json();
};
